import { FORM_DATA_ACTION } from "../constant";

export const setProjectDataAction = data => {
  return function(dispatch) {
    dispatch({
      type: FORM_DATA_ACTION.SET_PREVIEW_DATA,
      payload: data
    });
  };
};

export const clearProjectDataAction = data => {
  return function(dispatch) {
    dispatch({
      type: FORM_DATA_ACTION.CLEAR_PREVIEW_DATA
    });
  };
};
